@if (dataSource?.data.length) {
<div class="data-table-container">
  <stx-simple-report-table [columns]="columns" [dataSource]="dataSource" [displayedColumns]="displayedColumns"></stx-simple-report-table>
</div>
} @if (dataReady && dataSource?.data.length === 0) {
<div>
  <stx-empty-table-state></stx-empty-table-state>
</div>
}
